import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getUserProfile } from '@api/profile';
import { IUserProfile } from '@interfaces/profile';

export const handleGetUserProfile = createAsyncThunk<AxiosResponse<IUserProfile>, void>(
  'getUserProfile',
  getUserProfile,
);
